<div class="container ng-star-inserted">
  <div class="row no-gutters">
    <div class="col-12">
      <div class="popup-head d-flex flex-column w-100">
        <div class="d-flex align-items-center w-100 min-h55">
          <div class="d-flex align-items-center no-gutters mr-auto">

            <div class="pll10 d-flex align-items-center pr-4 border-right" tabindex="1" *ngIf="appointmentDetails">
              <div class="flmid">
                <div class="licplate LPNo d-flex scale">
                  <span class="icn-flag" [ngClass]="licensePlateClass"></span>
                  {{ appointmentDetails.licensePlate }}
                </div>
                <button class="btn btn-link ml-40" (click)="copyLicencePlateNo()" placement="bottom"
                    ngbTooltip="Copy No." aria-label="Center Align">
                    <em class="fas fa-copy fa-lg text-white"></em>
                </button>
              </div>
            </div>

            <div class="ml-4 font20 pr-4 border-right" *ngIf="appointmentDetails.widgetAppointmentNo">
              #{{ appointmentDetails.widgetAppointmentNo }}
              <button class="btn btn-link ml-2" (click)="copyTextWoNumber()" placement="bottom"
              ngbTooltip="Copy WA No." aria-label="Center Align">
              <em class="fas fa-copy fa-lg text-white"></em>
          </button>
            </div>

            <div class="ml-4 font20 pr-4">
              <div
                class="color-box shd shadow-none"
                [style.background-color]="appointmentDetails.typeColor"
              ></div>
              <span translate>
                {{ appointmentDetails.typeName }}
              </span>
            </div>
          </div>

          <div class="mr-2 edit-iconlist">
            <ul class="list-inline d-flex">
              <li>
                <a class="close" (click)="OnClose()" translate>
                  <span class="" aria-hidden="true">&times;</span>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

       <div class="d-flex align-items-center justify-content-between  bg-grey">
      <ul ngbNav #nav="ngbNav" class="nav-tabs">
        <li class="nav-item">
          <a translate class="nav-link" [class.active]="selectedTab === 1" (click)="selectedTab = 1">lblWidgetWorkOrder</a>
        </li>
        <li class="nav-item">
          <a translate class="nav-link" [class.active]="selectedTab === 2" (click)="selectedTab = 2" [class.disabled]="activeAppointmentList?.length === 0" 
          [attr.aria-disabled]="activeAppointmentList?.length === 0">
            lblActiveAppointment
            <span>({{activeAppointmentList?.length}})</span>
          </a>
        </li>
      </ul>
      <div [ngbNavOutlet]="nav" class="tab-content"></div>
      </div>

      <div class="ctm-tab custom-card overflow-none">
        <ng-cotainer  *ngIf="selectedTab === 1">
          <div class="scrollbar service-adviser-sidepopup card-accord" >
            <ngb-accordion #a="ngbAccordion" [activeIds]="activePanel">
              <ngb-panel id="first">
                <ng-template ngbPanelHeader class="custom-header ctm">
                  <div class="d-flex align-items-center">
                    <button
                      ngbPanelToggle
                      translate
                      class="btn d-flex w-100 align-items-center text-left"
                      aria-label="Center Align"
                    >
                      lblGeneralInfo
                      <ng-container *ngIf="!a.activeIds.includes('first')"
                        ><em class="fas fa-angle-down fa-lg ml-auto"></em>
                      </ng-container>
                      <ng-container *ngIf="a.activeIds.includes('first')"
                        ><em class="fas fa-angle-up fa-lg ml-auto"></em>
                      </ng-container>
                    </button>
                  </div>
                </ng-template>
                <ng-template ngbPanelContent>
                  <div class="p-2">
                    <div class="row" *ngIf="appointmentDetails && widgetAppointmentDetails">
                      <!-- Left Column - Vehicle Information -->
                      <div class="col-md-6">
                        <div class="row">
                          <div class="col-12 col-lg-6">
                            <div class="af-form-group">
                              <label>
                                <span translate>lblRegistrationNumber</span>
                              </label>
                              <div class="lbl-info">
                                <div class="flmid flex-wrap">
                                  <div class="licplate LPNo d-flex">
                                    <span
                                      class="icn-flag"
                                      [ngClass]="licensePlateClass"
                                    ></span>
                                    {{ widgetAppointmentDetails.licensePlate }}
                                  </div>
                                  <div class="imgWid">
                                    <img af-brand-logo [data-code]="appointmentDetails.brandCode" data-type="BRAND"
                                      [ngClass]="appointmentDetails.brand ? appointmentDetails.brand.name + '-icon common' : 'common'"
                                      [title]="appointmentDetails.brandCode"
                                      class="brandicon"
                                      alt="img"
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="col-12 col-lg-6">
                            <div class="af-form-group">
                              <label translate>lblModel</label>
                              <div class="lbl-info">
                                {{ widgetAppointmentDetails.modelName }}
                              </div>
                            </div>
                          </div>
                          <div class="col-12 col-lg-6" *ngIf="showPickDropService">
                            <div class="af-form-group form-check Cross pl-0">
                              <label translate>lblPickup/DropoffService</label>
                              <input
                                type="checkbox"
                                [value]="widgetAppointmentDetails.isPickUpDropOffService"
                                [checked]="widgetAppointmentDetails.isPickUpDropOffService"
                                disabled
                              />
                            </div>
                          </div>
                          <div class="col-12 col-lg-6" *ngIf="showPickDropService">
                            <div class="af-form-group">
                              <label translate>lblPickupTime/DropoffTime</label>
                              <div class="lbl-info">
                                {{
                                  widgetAppointmentDetails.pickUpDateTime
                                    ? (widgetAppointmentDetails.pickUpDateTime + "Z"
                                      | date: "HH:mm")
                                    : "-"
                                }}
                                |
                                {{
                                  widgetAppointmentDetails.dropOffDateTime
                                    ? (widgetAppointmentDetails.dropOffDateTime +
                                        "Z" | date: "HH:mm")
                                    : "-"
                                }}
                              </div>
                            </div>
                          </div>
                          <div class="col-12 col-lg-6">
                            <div class="af-form-group">
                              <label translate>lblCustomerPickUpTime</label>
                              <div class="lbl-info">
                                <span
                                  *ngIf="widgetAppointmentDetails.isAutoKey"
                                  translate
                                  >lblOutsideOpeningHours</span
                                >
                                <span
                                  *ngIf="!widgetAppointmentDetails.isAutoKey"
                                  translate
                                  >lblWithinBusinessHour</span
                                >
                              </div>
                            </div>
                          </div>
                          <div class="col-12 col-lg-6">
                            <div class="af-form-group">
                              <label translate>lblCustomerDropTime</label>
                              <div class="lbl-info">
                                <span
                                  *ngIf="widgetAppointmentDetails.isKeyDrop"
                                  translate
                                  >lblOutsideOpeningHours</span
                                >
                                <span
                                  *ngIf="!widgetAppointmentDetails.isKeyDrop"
                                  translate
                                  >lblWithinBusinessHour</span
                                >
                              </div>
                            </div>
                          </div>
                          <div class="col-12">
                            <div class="af-form-group">
                              <label translate>lblServices</label>
                              <div class="lbl-info">
                                {{
                                  widgetAppointmentDetails.serviceDetails
                                }}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      
                      <!-- Right Column - Customer Information -->
                      <div class="col-md-6">
                        <div class="row">
                          <div class="col-12 col-lg-6">
                            <div class="af-form-group">
                              <label translate>lblCustomer</label>
                              <div class="lbl-info">
                                {{ widgetAppointmentDetails.customerName }}
                              </div>
                            </div>
                          </div>
                          <div class="col-12 col-lg-6">
                            <div class="af-form-group">
                              <label translate>lblBookedDate</label>
                              <div class="lbl-info">
                                {{
                                  widgetAppointmentDetails.bookedDateTime + "Z"
                                    | date: "short"
                                }}
                              </div>
                            </div>
                          </div>
                          <div class="col-12 col-lg-6">
                            <div class="af-form-group form-check Cross pl-0">
                              <label translate>lblCustomerWaiting</label>
                              <input
                                type="checkbox"
                                [value]="widgetAppointmentDetails.isCustomerWaiting"
                                [checked]="widgetAppointmentDetails.isCustomerWaiting"
                                disabled
                              />
                            </div>
                          </div>
                          <div class="col-12 col-lg-6" *ngIf="isOfferActive">
                            <div class="af-form-group form-check Cross pl-0">
                              <label translate>lblOnlineCheck-Infacilityselected?</label>
                              <input
                                type="checkbox"
                                [value]="widgetAppointmentDetails.isCheckIn"
                                [checked]="widgetAppointmentDetails.isCheckIn"
                                disabled
                              />
                            </div>
                          </div>
                          <div class="col-12 col-lg-6">
                            <div class="af-form-group">
                              <label class="d-inline" translate>lblTransportation<span>:</span></label>
                              <div class="lbl-info">
                                <div *ngIf="widgetAppointmentDetails.isRentalCarRequire && IsRentalCarActive">
                                  <span class="lbl-info" translate>lblNewWidgetRentalCar</span>
                                </div>
                                <div *ngIf="widgetAppointmentDetails.needTransportTicket">
                                  <span class="lbl-info" translate>lblWishTransportTicket</span>
                                </div>
                                <div *ngIf="widgetAppointmentDetails.noNeedTransport">
                                  <span class="lbl-info" translate>lblWishNoTransport</span>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="col-12 col-lg-6">
                            <div class="af-form-group">
                              <label class="d-inline" translate>lblContactName </label> / <label class="d-inline" translate>lblContactMobile</label>
                              <div class="lbl-info" *ngIf="widgetAppointmentDetails.nomineeMobile; else load_else">
                                {{
                                  widgetAppointmentDetails.nomineeName
                                    ? widgetAppointmentDetails.nomineeName
                                    : "-"
                                }}
                                <span *ngIf="widgetAppointmentDetails.nomineeMobileCode[0]!='+'">+</span>{{widgetAppointmentDetails.nomineeMobileCode}} -
                                {{widgetAppointmentDetails.nomineeMobile}}
                              </div>
                              <ng-template #load_else>
                                <div class="lbl-info">
                                    {{"-"}}
                                </div>
                              </ng-template>
                            </div>
                          </div>
                          <div class="col-12 col-lg-6">
                            <div class="af-form-group">
                              <label class="d-inline" translate>lblDiscountCode </label>
                              <div class="lbl-info">
                                {{widgetAppointmentDetails.discountCode ? widgetAppointmentDetails.discountCode : "-"}}
                              </div>
                            </div>
                          </div>
                          <div class="col-12 col-lg-6">
                            <div class="af-form-group">
                              <label translate>lblCustomerCommets</label>
                              <div class="lbl-info">
                                {{
                                  widgetAppointmentDetails.customerComment
                                    ? widgetAppointmentDetails.customerComment
                                    : "-"
                                }}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </ng-template>
            </ngb-panel>

            <ngb-panel id="second">
              <ng-template ngbPanelHeader class="custom-header ctm">
                <div class="d-flex align-items-center">
                  <button
                    ngbPanelToggle
                    translate
                    class="btn d-flex w-100 align-items-center text-left"
                    aria-label="Center Align"
                  >
                    lblVehicleDetails
                    <ng-container *ngIf="this.widgetAppointmentDetails?.vehicleSource">
                      <span class="font16 ml-4">(</span>
                      <span class="font16" translate>lblSource:</span>
                      <span class="font16 clrBlue ml-1" translate *ngIf = "this.widgetAppointmentDetails?.vehicleSource == 'Manual'">lblByCustomer</span>
                      <span class="font16 clrBlue ml-1" translate *ngIf = "this.widgetAppointmentDetails?.vehicleSource == 'Local'">lblByLocal</span>
                      <span class="font16 clrBlue ml-1" translate *ngIf = "this.widgetAppointmentDetails?.vehicleSource == 'DF'">lblByDF</span>
                      <span class="font16">)</span>
                    </ng-container>
                    <ng-container *ngIf="!a.activeIds.includes('second')"
                      ><em class="fas fa-angle-down fa-lg ml-auto"></em>
                    </ng-container>
                    <ng-container *ngIf="a.activeIds.includes('second')"
                      ><em class="fas fa-angle-up fa-lg ml-auto"></em>
                    </ng-container>
                  </button>
                </div>
              </ng-template>
              <ng-template ngbPanelContent>
                <div class="p-2">
                  <div class="row" *ngIf="widgetAppointmentDetails">
                    <div class="col-6 col-lg-3">
                      <div class="af-form-group">
                        <label translate>lblMake
                          <strong class="mlt6 required" *ngIf="isVehicleDetailEditable"> * </strong>
                        </label>
                        <div class="lbl-info">
                          <ng-select name="brand" id="brand" [ngModelOptions]="{standalone: true}" placeholder="{{ 'lblSelectMake' | translate }}" required
                            [(ngModel)]="widgetAppointmentDetails.vehicle_Brand" (change)="onMakeSelected($event)"
                            [disabled]="!isVehicleDetailEditable">
                            <ng-template ng-header-tmp>
                              <span class="mbold w-66px">Code</span>
                              <span class="mbold" translate>lblMake</span>
                            </ng-template>

                            <ng-option *ngFor="let type of makeList" [value]="type.brandCode">
                              <span class="w-66px">{{type.brandCode}}</span>
                              <span class="mx-2 hide-ng-dropdown-panel">-</span>
                              <span>{{type.brandName}}</span>
                            </ng-option>
                          </ng-select>
                        </div>
                      </div>
                    </div>
                    <div class="col-6 col-lg-3">
                        <div class="af-form-group">
                          <label translate>lblModel
                            <strong class="mlt6 required" *ngIf="isVehicleDetailEditable"> * </strong>
                          </label>
                          <div class="lbl-info">
                            <ng-select  name="model" id="model" placeholder="{{ 'lblSelectModel' | translate }}" required
                            [(ngModel)]="widgetAppointmentDetails.vehicle_Model"  [disabled]="!isVehicleDetailEditable">
                            <ng-option *ngFor="let type of modelList" [value]="type.description">
                              {{type.description}}</ng-option>
                          </ng-select>
                          </div>

                        </div>
                      </div>
                    <div class="col-6 col-lg-3">
                      <div class="af-form-group">
                        <label translate>lblVinNumber
                          <strong class="mlt6 required" *ngIf="isVehicleDetailEditable"> * </strong>
                        </label>
                        <div class="lbl-info">
                          <input
                            type="text"
                            class="form-control"
                            [ngModelOptions]="{standalone: true}"
                            [(ngModel)]="widgetAppointmentDetails.vehicle_ChassisNo"
                            maxlength="25"
                            [disabled]="!isVehicleDetailEditable"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="col-6 col-lg-3">
                      <div class="af-form-group">
                        <label translate>lblTransmission
                          <strong class="mlt6 required" *ngIf="isVehicleDetailEditable"> * </strong>
                        </label>
                        <div class="lbl-info">
                          <ng-select name="transmission" id="transmission" [ngModelOptions]="{standalone: true}" placeholder="{{ 'lblSelectTransmission' | translate }}"
                            [(ngModel)]="widgetAppointmentDetails.vehicle_Transmission" [disabled]="!isVehicleDetailEditable">
                            <ng-template ng-header-tmp>
                              <span class="mbold w-66px">Code</span>
                              <span class="mbold" translate>lblTransmission</span>
                            </ng-template>

                            <ng-option *ngFor="let item of vehicleTransmissionList" [value]="item.transmisionName">
                              <span class="w-66px">{{item.code}}</span>
                              <span class="mx-2 hide-ng-dropdown-panel">-</span>
                              <span>{{item.transmisionName}}</span>
                            </ng-option>
                          </ng-select>
                        </div>
                      </div>
                    </div>
                    <div class="col-6 col-lg-3">
                      <div class="af-form-group">
                        <label translate>lblMileage
                          <strong class="mlt6 required" *ngIf="isVehicleDetailEditable"> * </strong>
                        </label>
                        <div class="lbl-info">
                          <input
                            type="text"
                            class="form-control"
                            [ngModelOptions]="{standalone: true}"
                            [(ngModel)]="widgetAppointmentDetails.vehicle_Mileage"
                            [disabled]="!isVehicleDetailEditable"
                            min="0" (keypress)="isDigit($event)"  maxlength="9"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="col-6 col-lg-3">
                      <div class="af-form-group">
                        <label translate>lblYear
                          <strong class="mlt6 required" *ngIf="isVehicleDetailEditable"> * </strong>
                        </label>
                        <div class="lbl-info">
                          <input id="template-year" name="year"
                            type="text"
                            class="form-control"
                            [ngModelOptions]="{standalone: true}"
                            [(ngModel)]="widgetAppointmentDetails.vehicle_Year"
                            [disabled]="!isVehicleDetailEditable"
                            required maxlength="4" (keypress)="isDigit($event)"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="col-6 col-lg-3">
                      <div class="af-form-group">
                        <label translate>lblColor
                          <strong class="mlt6 required" *ngIf="isVehicleDetailEditable"> * </strong>
                        </label>
                        <input
                          type="text"
                          class="form-control"
                          maxlength="20"
                          required
                          [ngModelOptions]="{standalone: true}"
                          [(ngModel)]="widgetAppointmentDetails.vehicle_Color"
                          [disabled]="!isVehicleDetailEditable"
                        />
                      </div>
                    </div>
                    <div class="col-6 col-lg-3">
                      <div class="af-form-group">
                        <label translate>lblVehicleType
                          <strong class="mlt6 required" *ngIf="isVehicleDetailEditable"> * </strong>
                        </label>
                        <div class="lbl-info">
                          <ng-select  name="vehicleType" id="vehicleType" [ngModelOptions]="{standalone: true}"
                            placeholder="{{ 'lblSelectVehical' | translate }}"
                          [(ngModel)]="widgetAppointmentDetails.vehicle_VehicleType" [disabled]="!isVehicleDetailEditable">
                          <ng-template ng-header-tmp>
                            <span class="mbold w-66px">Code</span>
                            <span class="mbold" translate>lblVehicalType</span>
                          </ng-template>

                          <ng-option *ngFor="let item of vehicleTypes" [value]="item.code">
                            <span class="w-66px">{{item.code}}</span>
                            <span class="mx-2 hide-ng-dropdown-panel">-</span>
                            <span>{{item.name}}</span>
                          </ng-option>
                        </ng-select>
                        </div>
                      </div>
                    </div>
                    <div class="col-6 col-lg-3">
                      <div class="af-form-group">
                        <label translate>lblFuelType
                          <strong class="mlt6 required" *ngIf="isVehicleDetailEditable"> * </strong>
                        </label>
                        <div class="lbl-info">
                          <ng-select name="transmission" id="transmission" [ngModelOptions]="{standalone: true}"
                          placeholder="{{ 'lblSelectFuelType' | translate }}" [(ngModel)]="widgetAppointmentDetails.vehicle_FuelType"
                          [disabled]="!isVehicleDetailEditable">
                            <ng-template ng-header-tmp>
                              <span class="mbold w-66px">Code</span>
                              <span class="mbold" translate>lblFuelType</span>
                            </ng-template>

                            <ng-option *ngFor="let type of fuels" [value]="type.fuelType">
                              <span class="w-66px">{{type.fuelType}}</span>
                              <span class="mx-2 hide-ng-dropdown-panel">-</span>
                              <span>{{type.description}}</span>
                            </ng-option>
                          </ng-select>
                        </div>
                      </div>
                    </div>
                    <div class="p-3">
                      <div class="row">
                        <div class="col-12 d-flex flex-sm-row flex-column justify-content-end mb15">
                          <button type="submit" (click)="IsEdit()"
                            class="btn btn-secondary btn-lg text-uppercase " *ngIf="isEdit" translate>
                            <ng-container translate>
                              lblEdit
                            </ng-container>
                          </button>
                          <button type="submit" *ngIf="isVehicleDetailEditable" (click)="editVehicleDetail()" class="btn btn-primary mr-sm-2 btn-lg" aria-label="Center Align"
                          translate>lblSaveChanges</button>
                        <a  (click)="OnCancleVehicleEdit()" *ngIf="isVehicleDetailEditable" class="btn btn-secondary btn-lg" translate>lblCancel</a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </ng-template>
            </ngb-panel>

            <ngb-panel id="third">
              <ng-template ngbPanelHeader class="custom-header ctm">
                <div class="d-flex align-items-center">
                  <button
                    ngbPanelToggle
                    translate
                    class="btn d-flex w-100 align-items-center text-left"
                    aria-label="Center Align"
                  >
                    lblCustomerVerification
                    <ng-container *ngIf="!a.activeIds.includes('third')"
                      ><em class="fas fa-angle-down fa-lg ml-auto"></em>
                    </ng-container>
                    <ng-container *ngIf="a.activeIds.includes('third')"
                      ><em class="fas fa-angle-up fa-lg ml-auto"></em>
                    </ng-container>
                  </button>
                </div>
              </ng-template>
              <ng-template ngbPanelContent>
                <div class="p-2">
                  <div class="row" *ngIf="appointmentDetails">
                    <div class="col-12">
                      <div class="af-form-group">
                        <p class="text-danger" translate>
                          lblCustomerVerificationNote
                        </p>
                      </div>
                    </div>

                    <div class="">
                      <!-- Header Main Title-->
                      <div class="no-col-relative w-100">
                        <div class="row">
                          <div class="col-5 border-y-black">&nbsp;</div>
                          <div
                            class="col-7 border-left-black border-y-black py-2"
                          >
                            <div class="flmid justify-content-between">
                              <div class="licplate LPNo d-flex lp-new-style">
                                <span class="icn-flag flag-NO"></span>
                                {{ appointmentDetails.licensePlate }}
                              </div>
                              <div class="fs-18px font-bitter font-weight-600" *ngIf="vehicleId">
                                <span translate>lblSource:</span>
                                <span class="font-bitter clrDarkBlue" translate
                                  >lblExistingDatabase</span
                                >
                              </div>
                              <div class="licplate LPNo d-flex invisible">
                                <span class="icn-flag flag-NO"></span>
                                {{ appointmentDetails.licensePlate }}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <!-- Content section-->
                      <div
                        class="position-relative no-col-relative w-100"
                        *ngIf="
                          widgetData &&
                          dataFactoryData &&
                          customerDriver &&
                          customerOwner &&
                          customerPayer &&
                          customerUser
                        "
                      >
                        <div class="row">
                          <div class="col-5 border-bottom-black py-2-5">
                            <div class="row">
                              <div class="col-3">&nbsp;</div>
                              <div class="col">
                                <div
                                  class="fs-16px font-bitter font-weight-600 text-center"
                                  translate
                                >
                                lblWidget
                                </div>
                              </div>
                              <div class="col">
                                <div
                                  class="fs-16px font-bitter font-weight-600 text-center"
                                  translate
                                >
                                  lblDataFactory &nbsp; <button (click)="GetDFInformation()"><em style="font-size:18px" class="fa">&#xf021;</em></button>
                                </div>

                              </div>
                            </div>
                          </div>
                          <div
                            class="col-7 border-left-black border-bottom-black py-2-5"
                          >
                            <div class="row">
                              <div
                                class="col-3"
                                [class.validated-from-widget]="
                                  customerOwner.isCopyFromWidget
                                "
                                [class.validated-from-datafactory]="
                                  customerOwner.isCopyFromDF
                                "
                              >
                                <!--Add this class 'validated-from-widget' conditionally after selection from dropdown -->
                                <div
                                  class="fs-16px font-bitter font-weight-600 text-center"
                                  translate
                                >
                                  lblOwner
                                </div>
                              </div>
                              <div
                                class="col-3"
                                [class.validated-from-widget]="
                                  customerPayer.isCopyFromWidget
                                "
                                [class.validated-from-datafactory]="
                                  customerPayer.isCopyFromDF
                                "
                              >
                                <!--Add this class 'validated-from-widget' conditionally after selection from dropdown -->
                                <div
                                  class="fs-16px font-bitter font-weight-600 text-center"
                                  translate
                                >
                                  lblPayer
                                </div>
                              </div>
                              <div
                                class="col-3"
                                [class.validated-from-widget]="
                                  customerUser.isCopyFromWidget
                                "
                                [class.validated-from-datafactory]="
                                  customerUser.isCopyFromDF
                                "
                              >
                                <div
                                  class="fs-16px font-bitter font-weight-600 text-center"
                                  translate
                                >
                                  lblUser
                                </div>
                              </div>
                              <div
                                class="col-3"
                                [class.validated-from-widget]="
                                  customerDriver.isCopyFromWidget
                                "
                                [class.validated-from-datafactory]="
                                  customerDriver.isCopyFromDF
                                "
                              >
                                <!--Add this class 'validated-from-datafactory' conditionally after selection from dropdown -->
                                <div
                                  class="fs-16px font-bitter font-weight-600 text-center"
                                  translate
                                >
                                  lblDriver
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-5 border-bottom-black py-2">
                            <div class="row align-items-center">
                              <div class="col-3">
                                <div class="fs-14px semibold" translate>
                                  lblCustomer
                                </div>
                              </div>
                              <div class="col">
                                <input
                                  type="text"
                                  class="form-control"
                                  [value]="widgetData[0].customerName"
                                  readonly
                                />
                              </div>
                              <div class="col">
                                <input
                                  type="text"
                                  class="form-control"
                                  [value]="dataFactoryData[0].customerName"
                                  readonly
                                />
                              </div>
                            </div>
                          </div>
                          <div
                            class="col-7 border-left-black border-bottom-black py-2"
                          >
                            <div class="row">
                              <div class="col">
                                <input
                                  type="text"
                                  class="form-control"
                                  [value]="customerOwner.customerName"
                                  readonly
                                />
                              </div>
                              <div class="col">
                                <input
                                  type="text"
                                  class="form-control"
                                  [value]="customerPayer.customerName"
                                  readonly
                                />
                              </div>
                              <div class="col">
                                <input
                                  type="text"
                                  class="form-control"
                                  [value]="customerUser.customerName"
                                  readonly
                                />
                              </div>
                              <div class="col">
                                <input
                                  type="text"
                                  class="form-control"
                                  [value]="customerDriver.customerName"
                                  readonly
                                />
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="row">
                          <div class="col-5 border-bottom-black py-2">
                            <div class="row align-items-center">
                              <div class="col-3">
                                <div class="fs-14px semibold" translate>
                                  lblMobile
                                </div>
                              </div>
                              <div class="col">
                                <ngx-intl-tel-input [selectFirstCountry]= "false" (keypress)="isDigit($event)"
                                [(ngModel)]="widgetData[0].cust_ContactNo"
                                [selectedCountryISO]="selectedCountryISO" [maxLength]="15" [phoneValidation]="false"
                                [separateDialCode]="true" [onlyCountries]="onlyCountries" [enablePlaceholder]="false"(countryChange)="onNomineeCountryChange($event)"
                                (change)="mobileNumberChanged()">
                                </ngx-intl-tel-input>
                              </div>
                              <div class="col">
                                <input
                                  type="text"
                                  class="form-control"
                                  [value]="dataFactoryData[0].cust_ContactNo"
                                  readonly
                                />
                              </div>
                            </div>
                          </div>
                          <div
                            class="col-7 border-left-black border-bottom-black py-2"
                          >
                            <div class="row">
                              <div class="col">
                                <input
                                  type="text"
                                  class="form-control"
                                  [value]="customerOwner.mobileNo"
                                  readonly
                                />
                              </div>
                              <div class="col">
                                <input
                                  type="text"
                                  class="form-control"
                                  [value]="customerPayer.mobileNo"
                                  readonly
                                />
                              </div>
                              <div class="col">
                                <input
                                  type="text"
                                  class="form-control"
                                  [value]="customerUser.mobileNo"
                                  readonly
                                />
                              </div>
                              <div class="col">
                                <input
                                  type="text"
                                  class="form-control"
                                  [value]="customerDriver.mobileNo"
                                  readonly
                                />
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="row">
                          <div class="col-5 border-bottom-black py-2">
                            <div class="row align-items-center">
                              <div class="col-3">
                                <div class="fs-14px semibold" translate>
                                  lblEmail
                                </div>
                              </div>
                              <div class="col">
                                <input
                                  type="text"
                                  class="form-control"
                                  [value]="widgetData[0].email"
                                  (input)="onInputChange($event)"
                                />
                              </div>
                              <div class="col">
                                <input
                                  type="text"
                                  class="form-control"
                                  [value]="dataFactoryData[0].email"
                                  readonly
                                />
                              </div>
                            </div>
                          </div>
                          <div
                            class="col-7 border-left-black border-bottom-black py-2"
                          >
                            <div class="row">
                              <div class="col">
                                <input
                                  type="text"
                                  class="form-control"
                                  [value]="customerOwner.email"
                                  readonly
                                />
                              </div>
                              <div class="col">
                                <input
                                  type="text"
                                  class="form-control"
                                  [value]="customerPayer.email"
                                  readonly
                                />
                              </div>
                              <div class="col">
                                <input
                                  type="text"
                                  class="form-control"
                                  [value]="customerUser.email"
                                  readonly
                                />
                              </div>
                              <div class="col">
                                <input
                                  type="text"
                                  class="form-control"
                                  [value]="customerDriver.email"
                                  readonly
                                />
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="row">
                          <div class="col-5 border-bottom-black py-2">
                            <div class="row align-items-center">
                              <div class="col-3">
                                <div class="fs-14px semibold" translate>
                                  lblAddressLine1
                                </div>
                              </div>
                              <div class="col">
                                <input
                                  type="text"
                                  class="form-control"
                                  [value]="widgetData[0].address1"
                                  readonly
                                />
                              </div>
                              <div class="col">
                                <input
                                  type="text"
                                  class="form-control"
                                  [value]="dataFactoryData[0].address1"
                                  readonly
                                />
                              </div>
                            </div>
                          </div>
                          <div
                            class="col-7 border-left-black border-bottom-black py-2"
                          >
                            <div class="row">
                              <div class="col">
                                <input
                                  type="text"
                                  class="form-control"
                                  [value]="customerOwner.address1"
                                  readonly
                                />
                              </div>
                              <div class="col">
                                <input
                                  type="text"
                                  class="form-control"
                                  [value]="customerPayer.address1"
                                  readonly
                                />
                              </div>
                              <div class="col">
                                <input
                                  type="text"
                                  class="form-control"
                                  [value]="customerUser.address1"
                                  readonly
                                />
                              </div>
                              <div class="col">
                                <input
                                  type="text"
                                  class="form-control"
                                  [value]="customerDriver.address1"
                                  readonly
                                />
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="row">
                          <div class="col-5 border-bottom-black py-2">
                            <div class="row align-items-center">
                              <div class="col-3">
                                <div class="fs-14px semibold" translate>
                                  lblAddressLine2
                                </div>
                              </div>
                              <div class="col">
                                <input
                                  type="text"
                                  class="form-control"
                                  [value]="widgetData[0].address2"
                                  readonly
                                />
                              </div>
                              <div class="col">
                                <input
                                  type="text"
                                  class="form-control"
                                  [value]="dataFactoryData[0].address2"
                                  readonly
                                />
                              </div>
                            </div>
                          </div>
                          <div
                            class="col-7 border-left-black border-bottom-black py-2"
                          >
                            <div class="row">
                              <div class="col">
                                <input
                                  type="text"
                                  class="form-control"
                                  [value]="customerOwner.address2"
                                  readonly
                                />
                              </div>
                              <div class="col">
                                <input
                                  type="text"
                                  class="form-control"
                                  [value]="customerPayer.address2"
                                  readonly
                                />
                              </div>
                              <div class="col">
                                <input
                                  type="text"
                                  class="form-control"
                                  [value]="customerUser.address2"
                                  readonly
                                />
                              </div>
                              <div class="col">
                                <input
                                  type="text"
                                  class="form-control"
                                  [value]="customerDriver.address2"
                                  readonly
                                />
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="row">
                          <div class="col-5 border-bottom-black py-2">
                            <div class="row align-items-center">
                              <div class="col-3">
                                <div class="fs-14px semibold" translate>
                                  lblCity
                                </div>
                              </div>
                              <div class="col">
                                <input
                                  type="text"
                                  class="form-control"
                                  [value]="widgetData[0].city"
                                  readonly
                                />
                              </div>
                              <div class="col">
                                <input
                                  type="text"
                                  class="form-control"
                                  [value]="dataFactoryData[0].city"
                                  readonly
                                />
                              </div>
                            </div>
                          </div>
                          <div
                            class="col-7 border-left-black border-bottom-black py-2"
                          >
                            <div class="row">
                              <div class="col">
                                <input
                                  type="text"
                                  class="form-control"
                                  [value]="customerOwner.city"
                                  readonly
                                />
                              </div>
                              <div class="col">
                                <input
                                  type="text"
                                  class="form-control"
                                  [value]="customerPayer.city"
                                  readonly
                                />
                              </div>
                              <div class="col">
                                <input
                                  type="text"
                                  class="form-control"
                                  [value]="customerUser.city"
                                  readonly
                                />
                              </div>
                              <div class="col">
                                <input
                                  type="text"
                                  class="form-control"
                                  [value]="customerDriver.city"
                                  readonly
                                />
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="row">
                          <div class="col-5 border-bottom-black py-2">
                            <div class="row align-items-center">
                              <div class="col-3">
                                <div class="fs-14px semibold" translate>
                                  lblCountry
                                </div>
                              </div>
                              <div class="col">
                                <input
                                  type="text"
                                  class="form-control"
                                  [value]="widgetData[0].country"
                                  readonly
                                />
                              </div>
                              <div class="col">
                                <input
                                  type="text"
                                  class="form-control"
                                  [value]="dataFactoryData[0].country"
                                  readonly
                                />
                              </div>
                            </div>
                          </div>
                          <div
                            class="col-7 border-left-black border-bottom-black py-2"
                          >
                            <div class="row">
                              <div class="col">
                                <input
                                  type="text"
                                  class="form-control"
                                  [value]="customerOwner.country"
                                  readonly
                                />
                              </div>
                              <div class="col">
                                <input
                                  type="text"
                                  class="form-control"
                                  [value]="customerPayer.country"
                                  readonly
                                />
                              </div>
                              <div class="col">
                                <input
                                  type="text"
                                  class="form-control"
                                  [value]="customerUser.country"
                                  readonly
                                />
                              </div>
                              <div class="col">
                                <input
                                  type="text"
                                  class="form-control"
                                  [value]="customerDriver.country"
                                  readonly
                                />
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="row">
                          <div class="col-5 border-bottom-black py-2">
                            <div class="row align-items-center">
                              <div class="col-3">
                                <div class="fs-14px semibold" translate>
                                  lblPostcode
                                </div>
                              </div>
                              <div class="col">
                                <input
                                  type="text"
                                  class="form-control"
                                  [value]="widgetData[0].postCode"
                                  readonly
                                />
                              </div>
                              <div class="col">
                                <input
                                  type="text"
                                  class="form-control"
                                  [value]="dataFactoryData[0].postCode"
                                  readonly
                                />
                              </div>
                            </div>
                          </div>
                          <div
                            class="col-7 border-left-black border-bottom-black py-2"
                          >
                            <div class="row">
                              <div class="col">
                                <input
                                  type="text"
                                  class="form-control"
                                  [value]="customerOwner.postCode"
                                  readonly
                                />
                              </div>
                              <div class="col">
                                <input
                                  type="text"
                                  class="form-control"
                                  [value]="customerPayer.postCode"
                                  readonly
                                />
                              </div>
                              <div class="col">
                                <input
                                  type="text"
                                  class="form-control"
                                  [value]="customerUser.postCode"
                                  readonly
                                />
                              </div>
                              <div class="col">
                                <input
                                  type="text"
                                  class="form-control"
                                  [value]="customerDriver.postCode"
                                  readonly
                                />
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="row">
                          <div class="col-5 border-bottom-black py-2">
                            <div class="row align-items-center">
                              <div class="col-3">
                                <div class="fs-14px semibold" translate>
                                  lblVehicleRelation
                                </div>
                              </div>
                              <div class="col">
                                <input
                                  type="text"
                                  class="form-control"
                                  [value]="widgetData[0].vehicleRelation"
                                  readonly
                                />
                              </div>
                              <div class="col">
                                <input
                                  type="text"
                                  class="form-control"
                                  [value]="dataFactoryData[0].vehicleRelation"
                                  readonly
                                />
                              </div>
                            </div>
                          </div>
                          <div
                            class="col-7 border-left-black border-bottom-black py-2"
                          >
                            <div class="row">
                              <div class="col">
                                <input
                                  type="text"
                                  class="form-control"
                                  [value]="customerOwner.vehicleRelation"
                                  readonly
                                />
                              </div>
                              <div class="col">
                                <input
                                  type="text"
                                  class="form-control"
                                  [value]="customerPayer.vehicleRelation"
                                  readonly
                                />
                              </div>
                              <div class="col">
                                <input
                                  type="text"
                                  class="form-control"
                                  [value]="customerUser.vehicleRelation"
                                  readonly
                                />
                              </div>
                              <div class="col">
                                <input
                                  type="text"
                                  class="form-control"
                                  [value]="customerDriver.vehicleRelation"
                                  readonly
                                />
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="row">
                          <div class="col-5 border-bottom-black py-2">
                            <div class="row align-items-center">
                              <div class="col-3">
                                <div class="fs-14px semibold" translate>
                                  lblCustomerNumber
                                </div>
                              </div>
                              <div class="col">
                                <input
                                  type="text"
                                  class="form-control"
                                  [value]="widgetData[0].customerNo"
                                  readonly
                                />
                              </div>
                              <div class="col">
                                <input
                                  type="text"
                                  class="form-control"
                                  [value]="dataFactoryData[0].customerNo"
                                  readonly
                                />
                              </div>
                            </div>
                          </div>
                          <div
                            class="col-7 border-left-black border-bottom-black py-2"
                          >
                            <div class="row">
                              <div class="col">
                                <input
                                  type="text"
                                  class="form-control"
                                  [value]="customerOwner.customerNo"
                                  readonly
                                />
                              </div>
                              <div class="col">
                                <input
                                  type="text"
                                  class="form-control"
                                  [value]="customerPayer.customerNo"
                                  readonly
                                />
                              </div>
                              <div class="col">
                                <input
                                  type="text"
                                  class="form-control"
                                  [value]="customerUser.customerNo"
                                  readonly
                                />
                              </div>
                              <div class="col">
                                <input
                                  type="text"
                                  class="form-control"
                                  [value]="customerDriver.customerNo"
                                  readonly
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <!-- Footer Validate And Dropdown-->
                      <div class="no-col-relative w-100">
                        <div class="row">
                          <div class="col-5 border-bottom-black py-2">
                            <div class="row align-items-center">
                              <div class="col-3">
                                <div class="fs-14px semibold" translate>
                                  lblValidate
                                </div>
                              </div>
                              <div class="col">
                                <button
                                  class="btn btn-blue w-100 text-uppercase"
                                  (click)="
                                    OpenCustomerValidation(widgetData[0], true)
                                  "
                                >
                                  <span translate>lblValidate</span>
                                </button>
                              </div>
                              <div class="col">
                                <button
                                  class="btn btn-orange w-100 text-uppercase"
                                  [disabled]="dataFactoryData && !dataFactoryData[0]?.vehicleRelation"

                                  (click)="
                                    OpenCustomerValidation(
                                      dataFactoryData[0],
                                      false
                                    )
                                  "
                                >
                                  <span translate>lblValidate</span>
                                </button>
                              </div>
                            </div>
                          </div>
                          <div class="col-7 border-bottom-black py-2"></div>
                        </div>

                        <div class="row">
                          <div class="col-5 border-bottom-black py-2">
                            <div class="row align-items-center select-position">
                              <div class="col-3">
                                <div class="fs-14px semibold" translate>
                                  lblCopyTo
                                </div>
                              </div>
                              <div class="col">
                                <ng-multiselect-dropdown
                                  [settings]="dropdownSettings"
                                  [data]="widgetOwnerTypeList"
                                  (onSelect)="onWidgetItemSelect($event)"
                                  (onDeSelect)="onWidgetDeSelect($event)"
                                  placeholder="{{ 'lblSelect' | translate }}"
                                  [(ngModel)]="selectedWidgetItems"
                                  [disabled]="isWidgetCopyToDisable"
                                >
                                </ng-multiselect-dropdown>
                              </div>
                              <div class="col">
                                <ng-multiselect-dropdown
                                  [settings]="dropdownSettings"
                                  [data]="DFOwnerTypeList"
                                  (onSelect)="onDFItemSelect($event)"
                                  (onDeSelect)="onDFDeSelect($event)"
                                  placeholder="{{ 'lblSelect' | translate }}"
                                  [(ngModel)]="selectedDFItems"
                                  [disabled]="isDFCopyToDisable" 
                                >
                                </ng-multiselect-dropdown>
                              </div>
                            </div>
                          </div>
                          <div class="col-7 border-bottom-black py-2">
                            <div class="row">
                              <div class="col">
                                <button
                                  class="btn btn-outline-secondary text-uppercase"
                                  (click)="onResetClick()"
                                >
                                  <span translate>lblReset</span>
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>


                  </div>
                </div>
              </ng-template>
            </ngb-panel>

            <ngb-panel id="fourth">
              <ng-template ngbPanelHeader class="custom-header ctm">
                  <div class="d-flex align-items-center">
                      <button ngbPanelToggle translate class="btn d-flex w-100 align-items-center"
                          aria-label="Center Align">
                          <span translate class="big" translate>lblBookedMechanics</span> (HH:mm)
                          <ng-container *ngIf="!a.activeIds.includes('fourth')"><em
                                  class="fas fa-angle-down fa-lg ml-auto"></em>
                          </ng-container>
                          <ng-container *ngIf="a.activeIds.includes('fourth')"><em
                                  class="fas fa-angle-up fa-lg ml-auto"></em>
                          </ng-container>
                      </button>
                  </div>
              </ng-template>
              <ng-template ngbPanelContent>
                <div class="p-2">
                  <div class="table-responsive tableMx-15">
                      <table class="tablest1">
                          <thead class="head-pt-0">
                              <tr>
                                  <th scope="col" translate>lblDate</th>
                                  <th scope="col" translate>lblMechanic</th>
                                  <th scope="col"><span translate>lblStart</span><br><span class="text-sm1"
                                          translate>(HH:MM)</span></th>
                                  <th scope="col"><span translate>lblEnd</span><br><span class="text-sm1"
                                          translate>(HH:MM)</span></th>
                                  <th scope="col"><span translate>lblDuration</span><br><span class="text-sm1"
                                          translate>(Minutes)</span></th>

                                </tr>
                            </thead>
                            <tbody>
                                <ng-container
                                    *ngIf="widgetAppointmentDetails && widgetAppointmentDetails?.list?.length>0">
                                    <tr  *ngFor="let plan of widgetAppointmentDetails?.list">
                                        <td >
                                          <span *ngIf="plan.selectedDate">
                                            {{ plan.selectedDate | date:'shortDate'}}
                                          </span>
                                        </td>
                                        <td *ngIf="widgetAppointmentDetails.mechanicName">
                                          <span>
                                          {{ widgetAppointmentDetails.mechanicName }}
                                          </span>
                                        </td>
                                        <td *ngIf="plan.startTime ">
                                          <span>
                                          {{ plan.startTime  }}
                                          </span>

                                      </td>
                                      <td *ngIf="plan.endTime">
                                        <span>
                                          {{ plan.endTime  }}
                                        </span>
                                        </td>
                                      <td *ngIf="plan.duration">
                                        <span>
                                          {{ plan.duration }}
                                        </span>
                                        </td>
                                  </tr>
                              </ng-container>
                          </tbody>
                      </table>
                  </div>
                </div>
              </ng-template>
          </ngb-panel>

          </ngb-accordion>

          </div>
        </ng-cotainer>
        <ng-cotainer  *ngIf="selectedTab === 2">
          <div class="scrollbar service-adviser-sidepopup card-accord">
            <div class="table-responsive max-h260">
              <table class="tablest1">
                  <thead>
                      <tr>
                          <th style="width:5%" scope="col" translate class="">lblType</th>
                          <th style="width:8%" scope="col" translate>lblWoNo</th>
                          <th style="width:15%" scope="col" translate>lblRegNumber
                          </th>
                          <th style="width:110px" scope="col" translate>lblSource</th>
                          <th style="width:18%" class="ST" scope="col" translate>
                              lblCustomer
                          </th>
                          <th style="width:18%" scope="col" translate>lblDealersName</th>
                          <th style="width:5%" scope="col" translate class="text-center">lblStatus
                          </th>
                          <th style="width:12%" scope="col" translate>lblBookedDate</th>
                          <th style="width:12%" scope="col" translate>lblCreatedDate</th>
                          <th scope="col" style="width:150px" translate class="text-center">lblAction
                          </th>
                      </tr>
                  </thead>
                  <tbody>
                      <ng-container *ngIf="activeAppointmentList?.length>0; else load_else">
                          <tr *ngFor="let appointment of activeAppointmentList; let i=index"> 
                              <td>
                                  <ngb-highlight [result]="appointment.appointmentType">
                                  </ngb-highlight>
                              </td>
                              <td>
                                  <ngb-highlight [result]="appointment.workOrderNo">
                                  </ngb-highlight>
                              </td>
                              <td>
                                  <div class="flmid">
                                      <div class="licplate LPNo d-flex">
                                          <span class="icn-flag" [ngClass]="licensePlateClass"></span>
                                          {{appointment.licensePlate}}
                                      </div>
                                      <div class="imgWid">
                                          <ng-container>
                                              <img af-brand-logo [data-code]="appointment.brand" data-type="BRAND"
                                                  class="{{appointment.brand.name}}-icon common"
                                                  [title]="appointment.brandCode" class="brandicon"
                                                  alt="img" />
                                          </ng-container>
                                      </div>
                                  </div>
                                  <div class="mt-1">
                                      <ngb-highlight class="flmid semibold fs-12px lh-16px"
                                          [result]="appointment.modelName"></ngb-highlight>
                                  </div>
                              </td>
                              <td>
                                  <ngb-highlight
                                      class="flmid sourceBox rounded-0 justify-content-center"
                                      [result]="appointment.sourceCreation">
                                  </ngb-highlight>
                              </td>
                              <td>
                                  <ngb-highlight class="fs-16px semibold lh-18px d-block"
                                      [result]="appointment.customerName">
                                  </ngb-highlight>
                                  <div>
                                      <em _ngcontent-xdg-c220=""
                                          class="fas fa-phone-flip fs-10px fa-lg mr-2 clr666"></em>
                                      <span class="fs-12px"
                                          *ngIf="appointment && appointment.mobileCode">+{{appointment.mobileCode}}-</span>
                                      <ngb-highlight class="fs-12px" [result]="appointment.mobileNo">
                                      </ngb-highlight>
                                  </div>

                              </td>
                              <td>
                                  <ngb-highlight [result]="appointment.dealerName">
                                  </ngb-highlight>
                              </td>
                              <td>
                                  <div class="mx-auto text-center">
                                      <div class="color-box"
                                          [ngbTooltip]="appointment.appointmentStatus"
                                          [style.background-color]="appointment.appointmentStatusColor">
                                      </div>
                                  </div>
                              </td>
                              <td>
                                  {{ appointment.bookedDate | date:'short'}}
                              </td>
                              <td>
                                  {{ appointment.createdDateTime | date:'short'}}
                              </td>
                              <td>
                                  <a class="btn btn-ico" ngbTooltip="{{'lblView' | translate}}"
                                      (click)="viewAppointment(appointment.id)">
                                      <em class="fas fa-eye fa-lg"></em>
                                  </a>
                              </td>

                      </ng-container>
                      <ng-template #load_else>
                          <tr>
                              <td colspan="10" class="no-record" translate>lblNoRecordsFound</td>
                          </tr>
                      </ng-template>
                  </tbody>
              </table>
            </div>
          </div>
        </ng-cotainer>


        <div class="p-3 bg-light pp-footer-top-brdr">
          <div class="row">
            <div class="col-12 d-flex flex-sm-row flex-column justify-content-end mb15">
              <button type="submit"
              (click)="onApproveReject(true)"
                        [disabled]="isWidgetCopyToDisable || appointmentDetails.statusId === 2" class="btn btn-success btn-lg text-uppercase " translate>
                <ng-container translate>
                  lblApprove
                </ng-container>

              </button>
              <ng-container>
                <button type="button" class="btn btn-danger btn-lg  ml-3 text-uppercase" [disabled]="appointmentDetails.statusId === 2"
                (click)="onApproveReject(false)" translate>
                lblReject
                </button>
              </ng-container>
              <a class="btn btn-secondary btn-lg ml-3 text-uppercase" (click)="OnClose()" translate>lblCancel</a>
            </div>
          </div>
        </div>


      </div>

    </div>
  </div>
</div>
